import { useLocale } from '@mirai/locale';
import { Notification, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { L10N } from '../Booking.l10n';
import * as style from '../Booking.module.css';
import { Summary } from '../components/Summary';

const FormEditDate = ({
  dataSource: { checkIn, checkInTime, checkOut, checkOutTime, ...dataSource },
  responseCalendar = {},
  onChange = () => {},
  ...others
}) => {
  const { translate } = useLocale();

  useEffect(() => {
    if (!responseCalendar) return;

    const { dates: { checkIn, checkOut } = {}, price: { value: price } = {} } = responseCalendar;

    onChange({ checkIn, checkOut, price });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseCalendar]);

  return (
    <View {...others} wide className={style.summaryContainer}>
      <Summary
        {...{
          title: translate(L10N.LABEL_CURRENT_BOOKING),
          dates: { checkIn, checkInTime, checkOut, checkOutTime },
          ...dataSource,
        }}
        testId="booking-current-summary"
      />
      <Summary
        {...{
          title: translate(L10N.LABEL_NEW_BOOKING),
          ...responseCalendar,
        }}
        testId="booking-new-summary"
      />
      {responseCalendar?.adjustDifferenceAtProperty && (
        <View className={style.adjustDifferent}>
          <Notification info wide>
            {translate(L10N.NOTIFICATION_ADJUST_DIFFERENT)}
          </Notification>
        </View>
      )}
    </View>
  );
};

FormEditDate.displayName = 'Mirai:Core:Booking:FormEditDate';

FormEditDate.propTypes = {
  dataSource: PropTypes.shape({
    checkIn: PropTypes.string,
    checkInTime: PropTypes.string,
    checkOut: PropTypes.string,
    checkOutTime: PropTypes.string,
  }).isRequired,
  responseCalendar: PropTypes.shape({
    adjustDifferenceAtProperty: PropTypes.bool,
  }),
  onChange: PropTypes.func,
};

export { FormEditDate };
